var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31173",
    d: "M0 0h14v14H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31174",
    d: "M11.667 1.167H2.334a1.17 1.17 0 00-1.167 1.167v10.5L3.5 10.501h8.167a1.17 1.17 0 001.167-1.167v-7a1.17 1.17 0 00-1.167-1.167zm0 8.167H3.016l-.683.682V2.334h9.334zM4.084 5.25H5.25v1.167H4.084zm4.667 0h1.166v1.167H8.75zm-2.333 0h1.166v1.167H6.417z",
    fill: "#001847"
  })));
}

export default SvgMessageBlack;